import { withOpen } from 'src/helpers/hooks/useOpenFromUrl';

/** The chips under the latest reply: next steps on it, then other features. */
export interface FollowUpSet {
  options: string[];
  explore: string[];
}

export const RELATED_FOLLOW_UPS = 3;
export const EXPLORE_FOLLOW_UPS = 2;

export const sameText = (a: string, b: string) =>
  a.trim().toLowerCase() === b.trim().toLowerCase();

/**
 * A reply's own chips, filled out from `fallback` where it has fewer than
 * a full set. Without a fallback (a chat the app opened) only its own are shown.
 */
export const resolveFollowUps = (
  own: FollowUpSet | null,
  fallback: FollowUpSet | null,
): FollowUpSet | null => {
  if (!fallback) return own;
  const options = own?.options.length ? own.options : fallback.options;
  const explore = [
    ...(own?.explore ?? []),
    ...fallback.explore.filter(
      (text) =>
        ![...options, ...(own?.explore ?? [])].some((o) => sameText(o, text)),
    ),
  ].slice(0, EXPLORE_FOLLOW_UPS);
  return options.length || explore.length ? { options, explore } : null;
};

/** While a reply is pending and silent this long, read it over HTTP instead. */
export const SOCKET_GRACE_MS = 6000;
export const POLL_INTERVAL_MS = 2500;
export const POLL_GIVE_UP_MS = 160000;

/** Where a navigate block goes: its page, set up and opening what it asks. */
export const navigateHref = ({
  path,
  search,
  open,
}: {
  path: string;
  search?: string;
  open?: string;
}) => withOpen(search ? `${path}?${search}` : path, open);

/**
 * After this long since the chat's last message the panel greets the user
 * with the launchpad again, under the chat so far. The backend's
 * SESSION_GAP_HOURS is the same break: it tells the model they are back.
 */
export const RETURNING_AFTER_MS = 3 * 60 * 60 * 1000;
